export type Step1WritingMode = 'external' | 'upload' | 'typed' | 'wizard';

export type CoverageTopicStatus =
  | 'addressed'
  | 'partial'
  | 'not_yet'
  | 'na'
  | 'covered_elsewhere';

export type PresentationVenue = 'workshop' | 'home_meeting' | 'sponsor_only' | 'other';

export type SponsorAttending = 'planning_yes' | 'planning_ask';

export interface Step1PresentationPlan {
  targetDate?: string;
  venue?: PresentationVenue;
  venueNote?: string;
  sponsorNote?: string;
  additionalPresentationsNote?: string;
  sponsorAttending?: SponsorAttending;
  updatedAt?: string;
}

export interface Step1WritingMetadata {
  /** Set when the member picks one of the four writing approaches */
  pathSelected?: boolean;
  mode?: Step1WritingMode;
  externalNote?: string;
  wordCount?: number;
  speakingMinutesEstimate?: { min: number; max: number };
  coverageStatus?: Record<string, CoverageTopicStatus>;
  presentationPlan?: Step1PresentationPlan;
  lastUpdated?: string;
  lastWorkedAt?: string;
  wizardChapterId?: string;
  wizardStepIndex?: number;
  hasContent: boolean;
  externalAcknowledged?: boolean;
  migratedAt?: string;
  migrationSource?:
    | 'legacy_v1_default_external'
    | 'new_user_default_external'
    | 'new_user_choose_path';
}

export function isStep1PathSelected(metadata: Step1WritingMetadata | null | undefined): boolean {
  return !!(metadata?.pathSelected && metadata.mode);
}

export interface Step1WizardAnswerEntry {
  examples: string[];
  status?: 'answered' | 'skipped' | 'na' | 'covered_elsewhere';
}

export interface Step1WritingInventoryPayload {
  _type: 'step1_writing_payload';
  wizardAnswers: Record<string, Step1WizardAnswerEntry>;
  wizardStepIndex: number;
  wizardChapterId: string;
  contentText?: string;
  coverageManualMarks?: Record<string, CoverageTopicStatus>;
  /** Fingerprint of wizardAnswers when contentText was last assembled */
  assembledAnswersFingerprint?: string;
  presentationPlan?: Step1PresentationPlan;
  originalFileName?: string;
  originalMimeType?: string;
  originalFileBase64?: string;
  lastSavedAt: string;
  /** Present on dated archive snapshots only */
  archivedAt?: string;
  archiveReason?: string;
}

export const STEP1_FIRST_STEP_INVENTORY_TYPE = 'step1-first-step';
export const STEP1_FIRST_STEP_VERSION = 'default';

export const STEP1_WRITING_TEMPLATE = `My name is ______, and I am a sex addict. This is the story of my addiction, my helplessness in controlling it on my own, and the unmanageability it has caused in my life.

[Family of origin and early experiences — how upbringing related to shame, validation, or secrecy around sex]

[How my addiction developed — progression over time]

[Examples of powerlessness — times I tried to stop and could not]

[Examples of unmanageability — impact on relationships, work, finances, health, spirit]

[Optional: my bottom and how I found recovery]

My name is ______, and I am a sex addict — and that is my story, so far.`;
